// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,json_types=true"
// @generated from file bundles/v1/count.proto (package bundles.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file bundles/v1/count.proto.
 */
export const file_bundles_v1_count: GenFile = /*@__PURE__*/ fileDesc("ChZidW5kbGVzL3YxL2NvdW50LnByb3RvEgpidW5kbGVzLnYxKnMKDklkZW50aWZpZXJUeXBlEh8KG0lERU5USUZJRVJfVFlQRV9VTlNQRUNJRklFRBAAEhoKFklERU5USUZJRVJfVFlQRV9DT09LSUUQARIkCiBJREVOVElGSUVSX1RZUEVfQ09OVEFDVF9QUk9QRVJUWRACYgZwcm90bzM");

/**
 * @generated from enum bundles.v1.IdentifierType
 */
export enum IdentifierType {
	/**
	 * @generated from enum value: IDENTIFIER_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: IDENTIFIER_TYPE_COOKIE = 1;
	 */
	COOKIE = 1,

	/**
	 * @generated from enum value: IDENTIFIER_TYPE_CONTACT_PROPERTY = 2;
	 */
	CONTACT_PROPERTY = 2,
}

/**
 * @generated from enum bundles.v1.IdentifierType
 */
export type IdentifierTypeJson = "IDENTIFIER_TYPE_UNSPECIFIED" | "IDENTIFIER_TYPE_COOKIE" | "IDENTIFIER_TYPE_CONTACT_PROPERTY";

/**
 * Describes the enum bundles.v1.IdentifierType.
 */
export const IdentifierTypeSchema: GenEnum<IdentifierType, IdentifierTypeJson> = /*@__PURE__*/ enumDesc(file_bundles_v1_count, 0);
